/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Project = {
  properties: {
    pk: {
      type: "number",
      isReadOnly: true,
    },
    name: {
      type: "string",
      isRequired: true,
      maxLength: 100,
      minLength: 1,
    },
    owner: {
      type: "string",
      isRequired: true,
      format: "uuid",
    },
    owner_username: {
      type: "string",
      isReadOnly: true,
    },
    team_id: {
      type: "number",
      isNullable: true,
      maximum: 2147483647,
      minimum: -2147483648,
    },
    tmp_project: {
      type: "string",
      isRequired: true,
      format: "uuid",
    },
    date_created: {
      type: "string",
      isReadOnly: true,
      format: "date-time",
    },
    date_updated: {
      type: "string",
      isReadOnly: true,
      format: "date-time",
    },
  },
};
